module.exports = __webpack_public_path__ + "static/img/texaspoke_th.d9ec9cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/texaspoke_th.png
// module id = Bofd
// module chunks = 1